(function () {
  'use strict';

  if (window.__rrCollectionQuickAddInitialized) return;
  window.__rrCollectionQuickAddInitialized = true;

  function getVariantData(quickAdd) {
    var json = quickAdd.querySelector('.js-variants-quick-add > script[type="application/json"]');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent || '[]');
    } catch (error) {
      console.warn('Unable to read collection Quick Add variants.', error);
      return [];
    }
  }

  function getSelectedOptions(quickAdd) {
    return Array.from(quickAdd.querySelectorAll('.js-variants-quick-add .m-variants__fieldset')).map(function (fieldset) {
      var selected = fieldset.querySelector('.m-variants__input:checked, select');
      return selected ? selected.value : null;
    });
  }

  function findSelectedVariant(quickAdd) {
    var selectedOptions = getSelectedOptions(quickAdd);
    var variants = getVariantData(quickAdd);

    return variants.find(function (variant) {
      return selectedOptions.every(function (value, index) {
        return !value || variant['option' + (index + 1)] === value;
      });
    });
  }

  function updateCardImage(quickAdd, variant) {
    var imageSource = variant && variant.featured_image && variant.featured_image.src;
    if (!imageSource && variant && variant.featured_media && variant.featured_media.preview_image) {
      imageSource = variant.featured_media.preview_image.src;
    }
    if (!imageSource) return;

    var card = quickAdd.closest('.m-product-card');
    var media = card && card.querySelector('.m-product-card__media');
    var image = media && media.querySelector('.m-product-card__image img');
    if (!image) return;

    updateImageElement(image, imageSource);
  }

  function updateImageElement(image, imageSource) {
    if (!image || !imageSource) return;

    image.src = imageSource;
    image.removeAttribute('srcset');
    image.setAttribute('data-variant-image', 'true');

    var media = image.closest('.m-product-card__media');
    if (media && media.classList.contains('show-secondary-image')) {
      media.classList.add('m-product-card--variant-image-selected');
    }
  }

  function updateFormVariant(quickAdd, variant) {
    if (!variant || !variant.id) return;

    var card = quickAdd.closest('.m-product-card');
    var form = card && card.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;
  }

  function updateSelectedVariant(quickAdd) {
    var variant = findSelectedVariant(quickAdd);
    if (!variant) return;

    updateFormVariant(quickAdd, variant);
    updateCardImage(quickAdd, variant);
  }

  function resetOpeningState(quickAdd) {
    var items = quickAdd.querySelector('.m-quick-add-variants__items');
    var toggle = quickAdd.querySelector('.js-quick-add-toggle button');
    if (!items) return;

    quickAdd.classList.remove('m-quick-add-variants--open');
    items.style.display = 'none';
    ['height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom', 'overflow', 'transition-duration', 'transition-property'].forEach(function (property) {
      items.style.removeProperty(property);
    });

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.js-quick-add-variants .m-variants__input, .js-quick-add-variants select');
    if (!input) return;

    var quickAdd = input.closest('.js-quick-add-variants');
    if (quickAdd) updateSelectedVariant(quickAdd);
  });

  document.addEventListener('click', function (event) {
    var close = event.target.closest('.js-quick-add-close');
    if (close) {
      event.preventDefault();
      event.stopPropagation();
      var quickAdd = close.closest('.js-quick-add-variants');
      if (quickAdd) resetOpeningState(quickAdd);
      return;
    }

    var toggle = event.target.closest('.js-quick-add-toggle');
    if (!toggle) return;

    var quickAdd = toggle.closest('.js-quick-add-variants');
    var button = toggle.querySelector('button');
    if (!quickAdd || !button) return;

    window.setTimeout(function () {
      button.setAttribute('aria-expanded', quickAdd.classList.contains('m-quick-add-variants--open') ? 'true' : 'false');
    }, 0);
  });

}());
